import { createFileRoute } from "@tanstack/react-router"
import SettingsPage from "@/settings/SettingsPage"

export const Route = createFileRoute("/(user)/t/$tenantSlug/settings")({
  component: RouteComponent,
})

function RouteComponent() {
  return <SettingsPage />
}
